'use strict';

(function () {
	'use strict';

	measurementsService.$inject = ['$http', '$q', 'appConfig', 'baseService'];
	angular.module('app.services').factory('measurementsService', measurementsService);

	function measurementsService($http, $q, appConfig, baseService) {
		'ngInject';

		var service = {
			getRaw: getRaw,

			getAggregated: getAggregated,
			getWindHistory: getWindHistory,

			getDeviceRecords: getDeviceRecords,

			getLatestDeviceMeasurements: getLatestDeviceMeasurements,
			getLatestFoiMeasurements: getLatestFoiMeasurements,
			getLatestWaterFoiMeasurements: getLatestWaterFoiMeasurements,

			getParkingRawMeasurements: getParkingRawMeasurements,

			getGranularities: getGranularities,

			toBeaufort: toBeaufort,
			toCompass: toCompass,
			toDirection: toDirection
		};

		return service;

		////////////////

		/**
   * 
   * @param {*} modality 
   * @param {*} fois 
   * @param {*} from 
   * @param {*} to 
   * @param {*} granularity 
   * @param {*} showOutOfRange 
   */
		function getAggregated(modality, fois, from, to, granularity) {
			var showOutOfRange = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

			var devices,
			    apiUrl,
			    body,
			    params = {};

			devices = _(fois).flatMap('devices').map('id').value();
			apiUrl = appConfig.apiUrl + '/rpc/measurements_averages';

			body = {
				_modality: modality.odm_table,
				_from: from.format(),
				_to: to.format(),
				_devices: "{" + _.join(devices, ',') + "}",
				_granularity: granularity.interval,
				_show_out_of_range: showOutOfRange
			};

			if (modality.slug === 'wind-speed') {
				apiUrl = appConfig.apiUrl + '/rpc/wind_measurements_averages';
				params = { select: 'at,avg:avg_speed,dir:avg_direction' };
				delete body._modality;
			} else if (modality.slug === 'rain') {
				apiUrl = appConfig.apiUrl + '/rpc/rain_measurements_averages';
				delete body._modality;
				// delete body._show_out_of_range;
			}

			return $http.post(apiUrl, JSON.stringify(body), {
				transformResponse: $http.defaults.transformResponse.concat(baseService.createDateAttrTransformer('at')),
				params: params
			}).then(function (response) {
				var data = response.data;
				var min = _(data).minBy('avg'),
				    max = _(data).maxBy('avg');

				return { modality: modality, min: min, max: max, measurements: data };
			});
		}

		/**
   * 
   * @param {*} modality 
   * @param {*} device 
   * @param {*} from 
   * @param {*} to 
   * @param {*} granularity 
   * @param {*} showOutOfRange 
   */
		function getDeviceRecords(modality, device, from, to, granularity) {
			var showOutOfRange = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
			var fillWithNulls = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;

			var devices,
			    apiUrl,
			    body,
			    params = {};

			apiUrl = appConfig.apiUrl + '/rpc/measurements_averages';

			body = {
				_modality: modality.odm_table,
				_from: from.format(),
				_to: to.format(),
				_devices: "{" + device.id + "}",
				_granularity: granularity,
				_show_out_of_range: showOutOfRange
			};

			if (modality.slug === 'wind-speed' || modality.slug === 'wind-direction') {
				apiUrl = appConfig.apiUrl + '/rpc/wind_measurements_averages';
				params = { select: 'at,avg:avg_speed,dir:avg_direction' };
				delete body._modality;
			} else if (modality.slug === 'rain') {
				apiUrl = appConfig.apiUrl + '/rpc/rain_measurements_averages';
				delete body._modality;
				delete body._show_out_of_range;
			}

			return $http.post(apiUrl, JSON.stringify(body), {
				transformResponse: $http.defaults.transformResponse.concat(baseService.createDateAttrTransformer('at')),
				params: params
			}).then(function (r) {
				var data = r.data;
				// 	step = 1, interval = granularity;

				// if (parseInt(granularity, 10) == granularity) {
				// 	step = granularity; interval = 'minutes';
				// }

				if (fillWithNulls === false) {
					var value = null;
					angular.forEach(data, function (item) {
						value = item.avg !== null ? item.avg : value;
						item.avg = value;
					});
				}

				// var keyMapper = (o) => o.at.toString(),
				// 	entryCreator = (date, o) => ({ avg: (fillWithNulls || !o) ? undefined : o.avg, at: date }),
				// 	measurements = baseService.fillInMissingEntries(data, from, to, step, interval, keyMapper, entryCreator);
				var min = _(data).minBy('avg'),
				    max = _(data).maxBy('avg');

				return { modality: modality, min: min, max: max, measurements: data };
			});
		}

		/**
   * 
   * @param {*} fois 
   * @param {*} from 
   * @param {*} to 
   */
		function getWindHistory(fois, from, to) {
			var devices, parameters;

			devices = _(fois).flatMap(function (foi) {
				return foi.devices;
			}).map('id').value();

			parameters = {
				_devices: '{' + _.join(devices, ',') + '}',
				_from: from.format(),
				_to: to.format()
			};

			return $http.post(appConfig.apiUrl + '/rpc/wind_history', JSON.stringify(parameters)).then(function (response) {
				var data = _(response.data),
				    totalOccurences = data.sumBy('occurrences');

				/** Fix North entries */
				data.remove({ 'direction_from': 348.75 }).forEach(function (e, index) {
					var source = data.find({ direction_from: 0, speed_from: e.speed_from, speed_to: e.speed_to }) || { direction_from: 0, speed_from: e.speed_from, speed_to: e.speed_to };
					source.direction_from = -11.25;
					source.occurrences += e.occurrences;
				});

				var calmOccurrences = data.remove(function (o) {
					return o.speed_from == 0;
				}).sumBy('occurrences');

				var groups = data
				/* */
				.map(function (o) {
					return {
						key: [o.speed_from, o.speed_to],
						order: (o.direction_to - 11.25) / 22.5,
						percent: o.occurrences / totalOccurences * 100
					};
				}).groupBy('key').map(function (o, key) {
					var defaults = [];
					for (var i = 0; i < 16; i++) {
						defaults.push({ order: i, percent: 0 });
					}

					var y = {
						key: _.compact(key.split(',')),
						values: _(defaults).merge(_.keyBy(o, 'order')).sortBy('order').map('percent').value()
					};

					return y;
				});

				return {
					calmness: calmOccurrences / totalOccurences * 100,
					ranges: groups.value()
				};
			});
		}

		/**
   * 
   * @param {*} modality 
   * @param {*} device 
   * @param {*} from 
   * @param {*} to 
   * @param {*} limit 
   */
		function getRaw(modality, device, from, to) {
			var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1000;

			var params;

			params = {
				'select': modality.slug === 'wind' ? 'at:created_at,value:speed' : 'at:created_at,value',
				'created_at': ['gte.' + from.format(), 'lte.' + to.format()],
				'device_id': 'eq.' + device.id,
				'limit': limit,
				'order': 'created_at.asc'
			};

			return $http.get(appConfig.apiUrl + '/' + modality.odm_table, {
				params: params,
				transformResponse: $http.defaults.transformResponse.concat(baseService.createDateAttrTransformer('at'))
			}).then(function (r) {
				var keyMapper = function keyMapper(o) {
					return moment(o.at).startOf('minute').toDate().toString();
				},
				    entryCreator = function entryCreator(date, o) {
					return { value: o ? o.value : undefined, at: date };
				},
				    measurements = baseService.fillInMissingEntries(r.data, from, to, 1, 'minute', keyMapper, entryCreator);

				return { device: device, modality: modality, measurements: r.data };
			});
		}

		/**
   * 
   * @param {*} device 
   * @param {*} from 
   * @param {*} to 
   */
		function getParkingRawMeasurements(device, from, to) {
			var params;

			params = {
				'created_at': ['gte.' + from.format(), 'lte.' + to.format()],
				'device_id': 'eq.' + device.id,
				'order': 'created_at.asc'
			};

			return $http.get(appConfig.apiUrl + '/parking', {
				params: params,
				transformResponse: $http.defaults.transformResponse.concat(baseService.createDateAttrTransformer('created_at'))
			}).then(function (r) {
				return r.data;
			});
		}

		/**
   * 
   * @param {*} devices 
   * @param {*} modalities 
   */
		function getLatestDeviceMeasurements() {
			var devices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var modalities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

			var config = {
				params: {
					'device_id': devices.length ? 'in.(' + _(devices).map('id').join(',') + ')' : null,
					'modality_id': modalities.length ? 'in.(' + _(modalities).map('id').join(',') + ')' : null
				},
				cache: true
			};

			return $http.get(appConfig.apiUrl + '/latest_measurements_averages', config).then(function (r) {
				return r.data;
			});
		}

		/**
   * 
   * @param {*} devices 
   * @param {*} modalities 
   */
		function getLatestWaterDeviceMeasurements() {
			var devices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var modalities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

			var config = {
				params: {
					'device_id': devices.length ? 'in.(' + _(devices).map('id').join(',') + ')' : null,
					'modality_id': modalities.length ? 'in.(' + _(modalities).map('id').join(',') + ')' : null
				},
				cache: true
			};

			return $http.get(appConfig.apiUrl + '/latest_water_measurements_averages', config).then(function (r) {
				return r.data;
			});
		}

		/**
   * 
   * @param {*} fois 
   * @param {*} modalities 
   */
		function getLatestFoiMeasurements() {
			var fois = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var modalities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

			var devices = _(fois).flatMap('devices').value();

			return getLatestDeviceMeasurements(devices, modalities).then(function (r) {
				var values = {},
				    measurements = _(r);

				fois.forEach(function (foi) {
					values[foi.id] = {};

					foi.modalities.forEach(function (modality) {

						values[foi.id][modality.slug] = measurements.filter(_.conforms({ device_id: _.partial(_.includes, foi.device_ids) })).filter({ modality_id: modality.id }).map('value').mean();
					});
				});

				return values;
			});
		}

		/**
   * 
   * @param {*} fois 
   * @param {*} modalities 
   */
		function getLatestWaterFoiMeasurements() {
			var fois = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var modalities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

			var devices = _(fois).flatMap('devices').value();

			return getLatestWaterDeviceMeasurements(devices, modalities).then(function (r) {
				var values = {},
				    measurements = _(r);

				fois.forEach(function (foi) {
					values[foi.id] = {};

					foi.modalities.forEach(function (modality) {

						values[foi.id][modality.slug] = measurements.filter(_.conforms({ device_id: _.partial(_.includes, foi.device_ids) })).filter({ modality_id: modality.id }).map('value').mean();
					});
				});

				return values;
			});
		}

		/**
   * 
   */
		function getGranularities() {
			return $q.when([{ id: 'hours', interval: '1 hour', value: 1, unit: 'hour', name: 'By hour', name_el: 'Ανά ώρα' }, { id: '3hours', interval: '3 hour', value: 3, unit: 'hour', name: 'Every 3 hours', name_el: 'Ανά 3ωρο' }, { id: '6hours', interval: '6 hour', value: 6, unit: 'hour', name: 'Every 6 hours', name_el: 'Ανά 6ωρο' }, { id: '12hours', interval: '12 hour', value: 12, unit: 'hour', name: 'Every 12 hours', name_el: 'Ανά 12ωρο' }, { id: 'days', interval: '1 day', value: 1, unit: 'day', name: 'By day', name_el: 'Ανά ημέρα' }, { id: 'weeks', interval: '1 week', value: 1, unit: 'week', name: 'By week', name_el: 'Ανά εβδομάδα' }]);
		}

		/**
   * 
   * @param {*} kmh 
   * @param {*} closed 
   */
		function toBeaufort(kmh) {
			var closed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			var kmhLimits = [1, 6, 11, 19, 30, 39, 50, 61, 74, 87, 102, 117, 177, 249, 332, 418, 512];

			for (var bf = 0; bf < kmhLimits.length; bf++) {
				if (kmh < kmhLimits[bf] || closed && kmh <= kmhLimits[bf]) {
					break;
				}
			}

			return bf;
		}

		/**
   * 
   * @param {*} degrees 
   * @param {*} compass 
   * @param {*} defaultValue 
   */
		function toCompass(degrees, compass, defaultValue) {
			var output, segmentSize, segment;

			if (degrees >= 0 && degrees <= 360) {
				output = defaultValue;

				if (compass.length) {
					segmentSize = 360 / compass.length;
					segment = Math.floor((degrees + segmentSize / 2) % 360 / segmentSize);
					output = compass[segment];
				}
			} else {
				output = '';
			}
			return output;
		}

		/**
   * 
   * @param {*} degrees 
   */
		function toDirection(degrees) {
			return Math.floor((degrees + 11.25) % 360 / 22.5) * 22.5 + 180;
		}
	}
})();